import ModalPremiereClotureHtml from './modal.premiere.cloture.html';
import ModalPremiereClotureController from './modal.premiere.cloture.controller.js';
export default {
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	},
	template: ModalPremiereClotureHtml,
	controller: ModalPremiereClotureController
};
